module.exports = __webpack_public_path__ + "img/mahsulot-4.2f28b8f0.png";